// The filter vocabulary FilteredTable and FilterUtils share. It lives here rather than in
// `boot/globals` because that module imports from the bounded contexts, so a context reaching back
// for this constant would close a cycle. `boot/globals` re-exports it for the callers that predate
// this file.
export const filterPropertyTypes = {
  StringInArray: 'StringInArray',
  ArrayInArray: 'ArrayInArray',
  StringMatch: 'StringMatch',
  Number: 'Number',
  Duration: 'Duration',
  Date: 'Date',
  Client: 'Client',
  User: 'User',
  ArrayContainsUser: 'ArrayContainsUser',
  NullValue: 'NullValue',
  Boolean: 'Boolean',
};

export const DATE_FILTER_OPERATORS = {
  IS_WITHIN: 'isWithin',
  IS_MORE_THAN: 'isMoreThan',
};
